/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getParcelAccounts } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetParcelAccounts(filters: any) {
  return useQuery({
    queryKey: userQueryKeys.parcelAccounts(filters),
    queryFn: () => getParcelAccounts({ params: filters }).then((res) => res.data),
  });
}
